'use strict';
import Mark from 'mark.js/dist/mark.es6';

(function () {
  const exports = {
    attachHighlighter: () => {
      const options = {
        element: 'span',
        className: 'results-highlight'
      };
      const searchInput = document.querySelector('#searchterm');
      const initialiseMarkheaders = new Mark(document.querySelectorAll('.c-accordion__header'));
      const initialiseMark = new Mark(document.querySelectorAll('.c-accordion__panel'));

      if (typeof (searchInput) !== 'undefined' && searchInput !== null) {
        const searchTerm = (document.querySelector('#searchterm')).value;
        initialiseMarkheaders.unmark({
          done: function () {
            initialiseMarkheaders.mark(searchTerm, options);
          }
        });
        initialiseMark.unmark({
          done: function () {
            initialiseMark.mark(searchTerm, options);
          }
        });
      }
    },
    attachTrackingEvents: () => {
      const searchInput = (document.querySelector('#searchterm'));
      if (typeof (searchInput) !== 'undefined' && searchInput !== null) {
        searchInput.closest('form').addEventListener('submit', () => {
          const data = {
            'event': 'event',
            'eventCategory': 'Suche FAQs',
            'eventAction': 'Send',
            'eventLabel': searchInput.value
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(data);
        });
      }
    },
    attachPopularityEvents: () => {
      // eslint-disable-next-line no-undef
      const faqApiUrl = faqApiPageUrl;

      const popularityItems = Array.from(document.querySelectorAll('[data-faq-popularity-item]'));

      if (popularityItems) {
        popularityItems.forEach((item) => {

          document.addEventListener('DOMContentLoaded', () => {
            item.addEventListener('click', (event) => {
              event.preventDefault();
              const el = event.target;

              const accordionItem = el.closest('[data-faq-popularity-item]');
              if (accordionItem) {
                const collapseElement = accordionItem.closest('.c-accordion').querySelector('[data-gs1-accordion-collapsed]');
                if (collapseElement) {
                  if (collapseElement.getAttribute('data-gs1-accordion-collapsed') === 'true') {
                    const xhttp = new XMLHttpRequest();
                    const data = new FormData();
                    data.append(
                      'tx_gs1faq_faq[faqItem]',
                      el.closest('[data-faq-popularity-item]').getAttribute('data-faq-popularity-item')
                    );
                    xhttp.open('POST', faqApiUrl, true);
                    xhttp.setRequestHeader('Content-Type', 'multipart/form-data');
                    xhttp.send(data);
                  }
                }
              }
            }, { capture: true });
          });
        });
      }
    }
  }

  exports.attachHighlighter();
  exports.attachTrackingEvents();
  exports.attachPopularityEvents();
})();

export default {}
